import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import drIsInLogo from "../../assets/dr-is-in.png";
import "./StudentTipsHome.css";

function getRole(): string {
  return (localStorage.getItem("role") || sessionStorage.getItem("role") || "").toLowerCase();
}

function getPortalReturnPath(location: any): string {
  const fromState = location?.state?.from;
  if (typeof fromState === "string" && fromState.trim()) return fromState.trim();

  const role = getRole();
  const ptReturn = sessionStorage.getItem("pt_portal_return");
  const studentReturn = sessionStorage.getItem("student_portal_return");

  if ((role === "pt" || role === "parent" || role === "teacher") && ptReturn?.trim()) {
    return ptReturn.trim();
  }

  if (studentReturn?.trim()) {
    return studentReturn.trim();
  }

  if (role === "pt" || role === "parent" || role === "teacher") {
    return "/parent-teacher-portal";
  }

  return "/student-portal";
}

function getTipsBasePath(): string {
  const role = getRole();
  if (role === "pt" || role === "parent" || role === "teacher") return "/pt/tips";
  return "/student/tips";
}

export default function StudentTipsHome() {
  const navigate = useNavigate();
  const location = useLocation();

  const portalReturn = useMemo(() => getPortalReturnPath(location), [location]);
  const tipsBase = useMemo(() => getTipsBasePath(), []);

  const handleBack = (e: React.MouseEvent) => {
    e.preventDefault();

    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate(portalReturn || "/student-portal", { replace: true });
  };

  const goTips = (cat: "physical" | "mental" | "everyday") => {
    try {
      const role = getRole();
      if (role === "pt" || role === "parent" || role === "teacher") {
        sessionStorage.setItem("pt_portal_return", portalReturn);
      } else {
        sessionStorage.setItem("student_portal_return", portalReturn);
      }
    } catch {}

    navigate(`${tipsBase}/${cat}`, { state: { from: portalReturn } });
  };

  return (
    <div className="tipsHome">
      <div className="tipsHomeTop">
        <button className="tipsHomeBack" type="button" onClick={handleBack}>
          ← Back
        </button>

        <div className="tipsHomeBrand">
          <img src={drIsInLogo} className="tipsHomeLogo" alt="Dr Is In" />
          <div>
            <div className="tipsHomeTitle">Health & Wellness</div>
            <div className="tipsHomeSub">Quick tips for feeling better, focusing more, and handling stress.</div>
          </div>
        </div>
      </div>

      <div className="tipsHomeGrid">
        <button className="tipsHomeCard physical" type="button" onClick={() => goTips("physical")}>
          <div className="tipsHomeCardTop">
            <div className="tipsHomeIcon">💪</div>
            <div className="tipsHomeCardText">
              <div className="tipsHomeCardTitle">Physical Wellness</div>
              <div className="tipsHomeCardSub">Sleep • Hydration • Movement • Nutrition</div>
            </div>
            <div className="tipsHomeArrow">›</div>
          </div>
          <div className="tipsHomeCardHint">Simple habits that help your body feel stronger today.</div>
        </button>

        <button className="tipsHomeCard mental" type="button" onClick={() => goTips("mental")}>
          <div className="tipsHomeCardTop">
            <div className="tipsHomeIcon">🧠</div>
            <div className="tipsHomeCardText">
              <div className="tipsHomeCardTitle">Mental Health & Stress</div>
              <div className="tipsHomeCardSub">Calm • Focus • Anxiety tools • Reset routines</div>
            </div>
            <div className="tipsHomeArrow">›</div>
          </div>
          <div className="tipsHomeCardHint">Quick tools to calm your brain and reset when things feel heavy.</div>
        </button>

        <button className="tipsHomeCard everyday" type="button" onClick={() => goTips("everyday")}>
          <div className="tipsHomeCardTop">
            <div className="tipsHomeIcon">✅</div>
            <div className="tipsHomeCardText">
              <div className="tipsHomeCardTitle">Everyday Healthy Habits</div>
              <div className="tipsHomeCardSub">Time • Routine • Small wins • Consistency</div>
            </div>
            <div className="tipsHomeArrow">›</div>
          </div>
          <div className="tipsHomeCardHint">Small daily decisions that add up fast for young adults.</div>
        </button>
      </div>
    </div>
  );
}